/**
 * Global shell nav items — for pages outside of any specific tool.
 * Each tool defines its own navConfig under src/tools/<tool>/navConfig.tsx.
 */
export const NAV_ITEMS = [];
